import { Button } from "@sellar-io/components";
import { OrderGetResponseType } from "@sellar-io/api-v2/types";
import { ReactElement, useState } from "react";
import { useNavigate } from "react-router";
import { twMerge } from "tailwind-merge";
import {
  Dialog,
  DialogNavigation,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { ORDER_SUPPLIER } from "../../../../constants/routes";
import { CancelOrderDialogContent } from "../CancelOrderDialogContent";

export function CancelRecreateOrderDialogActive({
  active,
  connectionId,
  order,
  onDismiss,
}: {
  active: boolean;
  connectionId: number;
  order: OrderGetResponseType;
  onDismiss: () => void;
}): ReactElement {
  const [step, setStep] = useState<"warning" | "cancellation">("warning");
  const navigate = useNavigate();
  const onSubmit = () => {
    return navigate(ORDER_SUPPLIER.href({ connectionId: connectionId }), {
      state: {
        initialOrderItems: order.OrderItems,
        initialRefundAmount: order.price,
      },
    });
  };
  return (
    <Dialog
      active={active}
      onDismiss={onDismiss}
      className={twMerge(step === "warning" && "max-w-[520px]")}
    >
      {step === "warning" ? (
        <>
          <DialogNavigation
            leftIcon={"CHEVRON_DOWN"}
            onClickLeftIcon={onDismiss}
            title={"Sorry, this order cannot be edited"}
            description={`This order has already been paid for by ${order.Retailer.Business.name}. If this order cannot be fulfilled as requested, you can cancel and re-create it.`}
          />
          <DialogCTA className={"w-full"}>
            <Button
              className={"w-full"}
              onClick={() => setStep("cancellation")}
            >
              Cancel & Re-create Order
            </Button>
          </DialogCTA>
        </>
      ) : (
        <CancelOrderDialogContent
          order={order}
          onDismiss={onDismiss}
          onSubmit={onSubmit}
        />
      )}
    </Dialog>
  );
}
